import React, { useState } from 'react';
import { Tabs } from 'antd';
import IloCountryMappingTab from './IloCountryMappingTab';
import IloIndicatorMappingTab from './IloIndicatorMappingTab';
import IloConvertFetchTab from './IloConvertFetchTab';

const { TabPane } = Tabs;

const IloTabGroup = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [checkRefreshKey, setCheckRefreshKey] = useState(0);

  const onConvertSuccess = () => {
    setRefreshKey(k => k + 1);
  };

  const onCheckSuccess = () => {
    setCheckRefreshKey(k => k + 1);
  };

  return (
    <Tabs defaultActiveKey="indicator">
      <TabPane tab="Comparison" key="comparison">
        <IloConvertFetchTab onConvertSuccess={onConvertSuccess} refreshTrigger={checkRefreshKey} />
      </TabPane>
      <TabPane tab="Indicator Mapping" key="indicator">
        <IloIndicatorMappingTab refreshTrigger={refreshKey} onCheckSuccess={onCheckSuccess} />
      </TabPane>
      <TabPane tab="Country Mapping" key="country">
        <IloCountryMappingTab />
      </TabPane>
    </Tabs>
  );
};

export default IloTabGroup;
